<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-text-field v-model="queryForm.text" label="车牌号/挂厢号" outlined dense clearable hide-details
          @keyup.enter="getdata()" @dblclick="showmtext()" />
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-autocomplete v-model="queryForm.vehicle_type" :items="vehicle_types" label="车辆吨位"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-autocomplete v-model="queryForm.type" :items="types" label="车辆类型"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-autocomplete v-model="queryForm.driverid" :items="drivers" label="选择司机"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <div class="d-flex align-center gap-1">
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            查询
          </v-btn>
          <v-checkbox v-model="queryForm.using" label="使用中(仅显示在有效期内)" hide-details></v-checkbox>
        </div>
      </v-col>
      <v-col cols="12" xl="4" lg="6" md="12" sm="12">
        <div class="d-flex align-center gap-1">
          <v-btn color="success" tile @click="showadd">
            新增车辆
          </v-btn>
          <v-btn color="cyan" tile dark @click="() => $refs.uploadRef.showupload()">
            导入车辆
          </v-btn>
          <v-btn color="purple" tile dark @click="getdata('download')">
            导出车辆
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.own_type" size="small" @change="(v) => getdata()">
      <a-tab-pane :key="0" tab="全部"></a-tab-pane>
      <a-tab-pane :key="1" tab="自有车"></a-tab-pane>
      <a-tab-pane :key="3" tab="包车"></a-tab-pane>
      <a-tab-pane :key="2" tab="临调车"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="limit" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height" :expanded.sync="expanded" item-key="_id"
        show-expand>
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.type="{ item }">
          <template v-for="type in types">
            <v-chip v-if="item.type === type.value" :key="type.value + '-' + item._id" label outlined small
              :color="$utils.textToBgColor(type.label)">{{ type.label }}</v-chip>
          </template>
        </template>
        <template v-slot:header.brand="{ }">
          <p>分配区域</p>
          <p v-if="queryForm.own_type <= 1">车辆品牌</p>
        </template>
        <template v-slot:item.brand="{ item }">
          <template v-if="username === 'root'">
            <p v-if="item.area" :style="{
              'color': $utils.textToBgColor(item.area)
            }">{{ item.area }}</p>
            <a-input v-else v-model="item.area" placeholder="分配区域" style="width:100%;color:green;" size="small"
              @blur="() => update(item._id, 'area', item.area)">
            </a-input>
            <a-dropdown v-if="item.own_type === 1 && (item.type === 1 || item.type === 3 || item.type === 4)">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <template v-if="item.brand">
                  <template v-for="brand in vehicle_brands">
                    <span v-if="item.brand === brand.value" :key="brand.value + '-1' + item._id" :style="{
                      'color': $utils.textToBgColor(brand.label)
                    }">{{ brand.label }}</span>
                  </template>
                </template>
                <template v-else>无</template>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => update(item._id, 'brand', e.key)">
                <template v-for="(brand, index) in vehicle_brands">
                  <template v-if="index > 0">
                    <a-menu-divider :key="brand.value + '-2' + item._id" />
                  </template>
                  <a-menu-item v-if="item.brand !== brand.value" :key="brand.value">
                    <a href="javascript:;" :style="{
                      'color': $utils.textToBgColor(brand.label)
                    }">{{ brand.label }}</a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>
          <template v-else>
            <p v-if="item.area" :style="{
              'color': $utils.textToBgColor(item.area)
            }">{{ item.area }}</p>
            <template v-for="brand in vehicle_brands">
              <p v-if="item.brand === brand.value" :key="brand.value + '-4' + item._id" :style="{
                'color': $utils.textToBgColor(brand.label)
              }">{{ brand.label }}</p>
            </template>
          </template>
        </template>
        <template v-slot:item.vehicle_number="{ item }">
          <p>
            {{ item.vehicle_number }}
            <v-menu v-if="item.qrimg" bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small>mdi-qrcode</v-icon>
              </template>
              <v-card>
                <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
                  {{ item.vehicle_number }}
                </v-card-title>
                <v-card-text>
                  <v-img max-height="256" max-width="256" :src="item.qrimg"></v-img>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn tile @click="downloadqrsvg(item)">下载</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </p>
          <a-dropdown v-if="username === 'root'">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <template v-if="item.costgroupid">
                <template v-for="costgroup in costgroups">
                  <span v-if="item.costgroupid === costgroup.value" :key="costgroup.value + '-1' + item._id">
                    <!-- <span :style="{ 'color': $utils.textToBgColor(costgroup.own_type) }">
                      [{{ costgroup.own_type }}]
                    </span>
                    <span :style="{ 'color': $utils.textToBgColor(costgroup.type) }">{{ costgroup.type }}</span>
                    <span :style="{ 'color': $utils.textToBgColor(costgroup.vehicle_type) }">
                      ({{ costgroup.vehicle_type }})
                    </span>
                    <span v-if="costgroup.brand" :style="{ 'color': $utils.textToBgColor(costgroup.brand) }">
                      {{ costgroup.brand }}
                    </span> -->
                    <span class="error--text"> {{ costgroup.cost }}元/月</span>
                  </span>
                </template>
              </template>
              <template v-else>无</template>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => update(item._id, 'costgroupid', e.key)">
              <template v-for="(costgroup, index) in costgroups">
                <template v-if="index > 0">
                  <a-menu-divider :key="costgroup.value + '-2' + item._id" />
                </template>
                <a-menu-item v-if="item.costgroupid !== costgroup.value" :key="costgroup.value">
                  <a href="javascript:;">
                    <span>
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.own_type) }">
                        [{{ costgroup.own_type }}]
                      </span>
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.type) }">{{ costgroup.type }}</span>
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.vehicle_type) }">
                        ({{ costgroup.vehicle_type }})
                      </span>
                      <span v-if="costgroup.brand" :style="{ 'color': $utils.textToBgColor(costgroup.brand) }">
                        {{ costgroup.brand }}
                      </span>
                      <span class="error--text"> {{ costgroup.cost }}元/月</span>
                    </span>
                  </a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
          <p class="error--text">{{ item.vehicle_onumber }}</p>
        </template>
        <template v-slot:item.vehicle_type="{ item }">
          <a-dropdown v-if="username === 'root'">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <template v-if="item.vehicle_type">
                <template v-for="vehicle_type in vehicle_types">
                  <span v-if="item.vehicle_type === vehicle_type.value" :key="vehicle_type.value + '-1' + item._id"
                    :style="{
                      'color': $utils.textToBgColor(vehicle_type.label)
                    }">{{ vehicle_type.label }}</span>
                </template>
              </template>
              <template v-else>无</template>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => update(item._id, 'vehicle_type', e.key)">
              <template v-for="(vehicle_type, index) in vehicle_types">
                <template v-if="index > 0">
                  <a-menu-divider :key="vehicle_type.value + '-2' + item._id" />
                </template>
                <a-menu-item v-if="item.vehicle_type !== vehicle_type.value" :key="vehicle_type.value">
                  <a href="javascript:;" :style="{
                    'color': $utils.textToBgColor(vehicle_type.label)
                  }">{{ vehicle_type.label }}</a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
          <span v-else>{{ item.vehicle_type }}</span>
        </template>
        <template v-slot:item.driverid="{ item }">
          <a-select v-model="item.driverid" :options="drivers" size="small" placeholder="-" :not-found-content="null"
            show-search :filter-option="filterOption" style="width:100%;" :disabled="!item.editable"
            @change="(v) => update(item._id, 'driverid', v)">
          </a-select>
        </template>
        <template v-slot:item.own_type="{ item }">
          <a-dropdown v-if="username === 'root'">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <template v-if="item.own_type">
                <template v-for="own_type in own_types">
                  <span v-if="item.own_type === own_type.value" :key="own_type.value + '-1' + item._id" :style="{
                    'color': $utils.textToBgColor(own_type.label)
                  }">{{ own_type.label }}</span>
                </template>
              </template>
              <template v-else>无</template>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => update(item._id, 'own_type', e.key)">
              <template v-for="(own_type, index) in own_types">
                <template v-if="index > 0">
                  <a-menu-divider :key="own_type.value + '-2' + item._id" />
                </template>
                <a-menu-item v-if="item.own_type !== own_type.value" :key="own_type.value">
                  <a href="javascript:;" :style="{
                    'color': $utils.textToBgColor(own_type.label)
                  }">{{ own_type.label }}</a>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
          <template v-else>
            <template v-for="own_type in own_types">
              <span v-if="item.own_type === own_type.value" :key="own_type.value + '-4' + item._id" :style="{
                'color': $utils.textToBgColor(own_type.label)
              }">{{ own_type.label }}</span>
            </template>
          </template>
        </template>
        <template v-slot:item.duration="{ item }">
          <template v-if="username === 'root'">
            <a-input-group compact>
              <a-input v-model="item.start_day" placeholder="开始" style="width:85%;color:green;" size="small"
                @blur="() => update(item._id, 'start_day', item.start_day)">
              </a-input>
              <a-button icon="reload" size="small" style="width:15%;" @click="loadfirst(item._id)">
              </a-button>
            </a-input-group>
            <a-input-group compact>
              <a-input v-model="item.end_day" placeholder="结束" style="width:85%;color:red;" size="small"
                @blur="() => update(item._id, 'end_day', item.end_day)">
              </a-input>
              <a-button icon="reload" size="small" style="width:15%;">
              </a-button>
            </a-input-group>
          </template>
          <template v-else>
            <p v-if="item.start_day" class="success--text">{{ item.start_day }}</p>
            <p v-if="item.end_day" class="error--text">{{ item.end_day }}</p>
          </template>
        </template>
        <template v-slot:item.location="{ item }">
          <!-- <p v-if="item.location">{{ item.location.title }}</p> -->
          <p v-if="item.location" style="font-size:12px;">{{ item.location.address }}</p>
          <!-- <p v-if="item.location && item.location.longitude">
            {{ item.location.longitude }},{{ item.location.latitude }}
          </p> -->
          <p v-if="item.locationTime" style="font-size:12px;" class="error--text">
            {{ item.locationTime }}
          </p>
          <v-btn v-if="username === 'root'" icon @click="refreshlocation(item._id)">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.optime="{ item }">
          <p style="font-size:12px;">{{ item.optime }}</p>
          <p style="font-size:12px;">{{ item.opby }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <a-space>
            <v-btn v-if="item.editable" text tile small color="success" @click="showedit(item._id)"> 编辑 </v-btn>
            <a-popconfirm v-if="item.removeable" title="删除车辆" ok-text="确定" cancel-text="取消" @confirm="remove(item._id)">
              <v-btn text tile small color="error"> 删除 </v-btn>
            </a-popconfirm>
            <span v-if="item.blocked" class="error--text">已拉黑</span>
            <a-popconfirm v-else title="拉黑车辆" ok-text="确定" cancel-text="取消" @confirm="block(item._id)">
              <v-btn text tile small color="error"> 拉黑 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td :colspan="4">
            <a-dropdown v-if="username === 'root'">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <template v-if="item.costgroupid">
                  <template v-for="costgroup in costgroups">
                    <span v-if="item.costgroupid === costgroup.value" :key="costgroup.value + '-4' + item._id">
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.own_type) }">
                        [{{ costgroup.own_type }}]
                      </span>
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.type) }">{{ costgroup.type }}</span>
                      <span :style="{ 'color': $utils.textToBgColor(costgroup.vehicle_type) }">
                        ({{ costgroup.vehicle_type }})
                      </span>
                      <span v-if="costgroup.brand" :style="{ 'color': $utils.textToBgColor(costgroup.brand) }">
                        {{ costgroup.brand }}
                      </span>
                      <span class="error--text"> {{ costgroup.cost }}元/月</span>
                    </span>
                  </template>
                </template>
                <template v-else>无</template>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => update(item._id, 'costgroupid', e.key)">
                <template v-for="(costgroup, index) in costgroups">
                  <template v-if="index > 0">
                    <a-menu-divider :key="costgroup.value + '-5' + item._id" />
                  </template>
                  <a-menu-item v-if="item.costgroupid !== costgroup.value" :key="costgroup.value">
                    <a href="javascript:;">
                      <span>
                        <span :style="{ 'color': $utils.textToBgColor(costgroup.own_type) }">
                          [{{ costgroup.own_type }}]
                        </span>
                        <span :style="{ 'color': $utils.textToBgColor(costgroup.type) }">{{ costgroup.type }}</span>
                        <span :style="{ 'color': $utils.textToBgColor(costgroup.vehicle_type) }">
                          ({{ costgroup.vehicle_type }})
                        </span>
                        <span v-if="costgroup.brand" :style="{ 'color': $utils.textToBgColor(costgroup.brand) }">
                          {{ costgroup.brand }}
                        </span>
                        <span class="error--text"> {{ costgroup.cost }}元/月</span>
                      </span>
                    </a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
            <template v-else>
              <template v-for="costgroup in costgroups">
                <p v-if="item.costgroupid === costgroup.value" :key="costgroup.value + '-7' + item._id">
                  <span :style="{ 'color': $utils.textToBgColor(costgroup.own_type) }">[{{ costgroup.own_type }}]</span>
                  <span :style="{ 'color': $utils.textToBgColor(costgroup.type) }">{{ costgroup.type }}</span>
                  <span :style="{ 'color': $utils.textToBgColor(costgroup.vehicle_type) }">
                    ({{ costgroup.vehicle_type }})
                  </span>
                  <span v-if="costgroup.brand" :style="{ 'color': $utils.textToBgColor(costgroup.brand) }">
                    {{ costgroup.brand }}
                  </span>
                  <span class="error--text"> {{ costgroup.cost }}元/月</span>
                </p>
              </template>
            </template>
          </td>
        </template>
      </v-data-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="580px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="form.type" :items="types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.brand" :items="vehicle_brands"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      品牌
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.vehicle_type" :items="vehicle_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      车辆类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.own_type" :items="own_types" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      所属类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!--牵引头 30吨 电车-->
                <!--载货车头 12吨 电车-->
                <v-col cols="6" v-if="form.type === 1 || form.type === 4">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <!--挂箱-->
                <v-col cols="6" v-if="form.type === 2">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      挂箱号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <!--载货车 12吨-->
                <v-col cols="6" v-if="form.type === 3">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <!--载货车箱 12吨-->
                <v-col cols="6" v-if="form.type === 5">
                  <v-text-field v-model="form.vehicle_number" :rules="[vrules.required]" outlined dense>
                    <template v-slot:label>
                      车箱号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 1 || form.type === 3">
                  <v-text-field v-model="form.vehicle_onumber" outlined dense>
                    <template v-slot:label>
                      原车牌号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" v-if="form.type === 2">
                  <v-autocomplete v-model="form.vehicle_gtype" :items="vehicle_gtypes" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      挂箱类型 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.driverid" :items="drivers" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" outlined dense clearable>
                    <template v-slot:label>
                      绑定司机
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.start_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.start_day" label="生效开始" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.start_day_menu.save(form.start_day); start_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.end_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.end_day" label="生效结束" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.end_day_menu.save(form.end_day); end_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="form.costgroupid" :items="costgroups"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable>
                    <template v-slot:label>
                      车辆成本
                    </template>
                    <template v-slot:selection="{ item }">
                      <p>
                        <span :style="{ 'color': $utils.textToBgColor(item.own_type) }">[{{ item.own_type }}]</span>
                        <span :style="{ 'color': $utils.textToBgColor(item.type) }">{{ item.type }}</span>
                        <span :style="{ 'color': $utils.textToBgColor(item.vehicle_type) }">
                          ({{ item.vehicle_type }})
                        </span>
                        <span v-if="item.brand" :style="{ 'color': $utils.textToBgColor(item.brand) }">
                          {{ item.brand }}
                        </span>
                        <span class="error--text"> {{ item.cost }}元/月</span>
                      </p>
                    </template>
                    <template v-slot:item="{ item }">
                      <p>
                        <span :style="{ 'color': $utils.textToBgColor(item.own_type) }">[{{ item.own_type }}]</span>
                        <span :style="{ 'color': $utils.textToBgColor(item.type) }">{{ item.type }}</span>
                        <span :style="{ 'color': $utils.textToBgColor(item.vehicle_type) }">
                          ({{ item.vehicle_type }})
                        </span>
                        <span v-if="item.brand" :style="{ 'color': $utils.textToBgColor(item.brand) }">
                          {{ item.brand }}
                        </span>
                        <span class="error--text"> {{ item.cost }}元/月</span>
                      </p>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-checkbox v-if="form._id === ''" v-model="continueadd" label="连续添加" hide-details></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="mtextmodel" persistent max-width="580px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          批量查询
          <v-icon @click="mtextmodel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="queryForm.text" label="车牌号/挂箱号" rows="4" outlined dense hide-details>
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile @click="getdata()">查询</v-btn>
          <v-btn tile @click="mtextmodel = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UploadTask ref="uploadRef" modelTitle="导入车辆"
      :alertText="`上传Excel文件需包含 <span class='error--text'>类型</span>、<span class='error--text'>车牌号</span>、<span>挂箱号</span>、<span class='error--text'>原车牌号</span>、<span class='error--text'>车辆类型</span>、<span>车辆容积</span>、<span class='error--text'>所属类型</span>、<span>电池容量</span> 字段。类型：<span class='error--text'>车头、挂箱、整车</span>，车辆类型：<span class='error--text'>5吨、8吨、12吨、20吨、30吨、40吨</span>，所属类型：<span class='error--text'>自有车、临调、包车</span>。`"
      uploadType="vehiclevehicle" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
import QRCode from "qrcode-svg";
import svg64 from 'svg64';
import { jsPDF } from 'jspdf'
import 'svg2pdf.js'
export default {
  name: "VehicleDrawHead",
  data() {
    return {
      queryForm: {
        own_type: 0,
        text: "",
        vehicle_type: null,
        type: null,
        driverid: null,
        using: true,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { text: '', value: 'data-table-expand' },
        { text: "序号", value: "index", width: 50, align: "center" },
        { text: "类型", value: "type", width: 100, align: "center" },
        { text: "品牌", value: "brand", width: 100, align: "center" },
        { text: "车牌号", value: "vehicle_number", width: 110, align: "center" },
        { text: "车辆类型", value: "vehicle_type", width: 80, align: "center" },
        { text: "当前司机", value: "driverid", width: 120, align: "center" },
        { text: "所属类型", value: "own_type", width: 80, align: "center" },
        { text: "有效期", value: "duration", width: 150, align: "center" },
        { text: "当前位置", value: "location", width: 240, align: "center" },
        { text: "更新时间", value: "optime", width: 100, align: "center" },
        // { text: "操作人", value: "opby", width: 120, align: "center" },
        { text: "操作", value: "action", width: 150, align: "center", fixed: "right" },
      ],
      expanded: [],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      vehicle_brands: [],
      vehicle_types: [],
      vehicle_gtypes: [],
      types: [],
      own_types: [],
      teams: [],
      drivers: [],
      vehiclestates: [],
      costgroups: [],
      valid: true,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      start_day_menu: false,
      end_day_menu: false,
      form: {
      },
      mtextmodel: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 240;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 240;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/list", { page: this.page, limit: this.limit, ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        this.mtextmodel = false;
        if (action === 'download' && res.data.url) {
          return this.$download(res.data.url, res.data.name);;
        }
        if (res.code === 0) {
          this.list = res.data.list.map(n => {
            let qrsvg = n.xcxurl ? new QRCode({
              content: n.xcxurl,
              padding: 2,
              width: 512,
              height: 512,
              join: true,
            }).svg() : null
            // .replace('<?xml version="1.0" standalone="yes"?>', '');
            const qrimg = qrsvg ? svg64(qrsvg) : null;
            // console.log(qrimg);
            return {
              ...n,
              qrsvg,
              qrimg,
            };
          });
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.vehicle_types = res.data.vehicle_types;//车辆类型
          this.vehicle_gtypes = res.data.vehicle_gtypes;//挂箱类型:1：单轴挂、2：双轴挂
          this.types = res.data.types;
          this.own_types = res.data.own_types;
          this.teams = res.data.teams;
          this.drivers = res.data.drivers;
          this.vehiclestates = res.data.vehiclestates;
          this.vehicle_brands = res.data.vehicle_brands;
          this.costgroups = res.data.costgroups;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    downloadqrsvg(item) {
      let width = 512;
      let height = 512;
      const doc = new jsPDF('l', 'pt', [width, height]);
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(item.qrsvg, "image/svg+xml");
      const svgElement = svgDoc.documentElement;
      doc.svg(svgElement, {
        x: 0,
        y: 0,
        width,
        height
      }).then(() => {
        // save the created pdf
        doc.save(`${item.vehicle_number}.pdf`)
      })
    },
    showmtext() {
      this.mtextmodel = true;
    },
    getinfo(_id) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/vehiclevehicle/info", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.form = res.data.form;
          this.costgroups = res.data.costgroups;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.getinfo().then(() => {
        this.modeltitle = "新增车辆";
        this.continueadd = false;
        this.model = true;
      });
    },
    showedit(_id) {
      this.getinfo(_id).then(() => {
        this.modeltitle = "编辑车辆";
        this.continueadd = false;
        this.model = true;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = this.continueadd;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    loadfirst(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/loadfirst", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$message.success(res.data.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    refreshlocation(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/refreshlocation", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    block(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehiclevehicle/block", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  padding: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
